import { createAuthClient as createBetterAuthClient } from "better-auth/client";

export interface AuthClientOptions {
  baseURL: string;
  // The Cryptolect API mounts Better Auth at `/v1/auth/*` (see
  // `apps/api/src/index.ts`), not the Better Auth default `/api/auth`.
  // Callers pass `basePath: "/v1/auth"` so the client composes URLs
  // against the matching server path.
  basePath?: string;
}

export function createAuthClient(options: AuthClientOptions) {
  return createBetterAuthClient({
    baseURL: options.baseURL,
    basePath: options.basePath,
  });
}

export type AuthClient = ReturnType<typeof createAuthClient>;
